import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { SessionQuery } from '@state/session/session.query';
import { AES_URL_STORAGE_KEY, SESSION_STORAGE_KEY } from '@core/constants';
import { switchMap } from 'rxjs/operators';
import { SessionService } from '@state/session/session.service';
import { NavController } from '@ionic/angular';
import { Preferences }  from '@capacitor/preferences'
@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {
    constructor(
        private navController: NavController,
        private sessionQuery: SessionQuery,
        private sessionService: SessionService) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.sessionQuery.logged) {
            return true;
        }

        return from(this.getStorage()).pipe(
            switchMap(([aesUrl, sessionId]: { value: string }[]) => {
                if (aesUrl.value && sessionId.value) {
                    this.sessionService.update({
                        aesUrl: aesUrl.value,
                        sessionId: sessionId.value
                    });
                    return of(true);
                }

                this.navController.navigateRoot('/login');
                return of(false);
            })
        );
    }

    private async getStorage(): Promise<{ value: string }[]> {
        return await Promise.all([Preferences.get({ key: AES_URL_STORAGE_KEY }), Preferences.get({ key: SESSION_STORAGE_KEY })]);
    }
}
